module.exports="#define GLSLIFY 1\nuniform sampler2D _MainTex;\n\nvarying vec2 vUv;\nvoid main()\n{\n\tgl_FragColor = texture2D(_MainTex, vUv);\n}";